export function getWhatsappLinkFromPhone(phone) {
  return "https://wa.me/55" + phone.replace(/[^0-9]/g, "");
}
